import { render, staticRenderFns } from "./DealReOpenModal.vue?vue&type=template&id=02248f5b&"
import script from "./DealReOpenModal.vue?vue&type=script&lang=ts&"
export * from "./DealReOpenModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports